<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/preaddmatchpending")
          i.fa.fa-tasks
          span.ml-1 {{ $t("ui.pre_add_match_pending") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-1
              SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getPreAddMatchPendingList" size="sm" variant="info")
            div.col-md-3
              b-input-group(size="sm").mb-1
                b-input-group-text(slot="prepend")
                  div.d-flex.justify-content-center.align-items-center
                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                b-input(v-model="refreshTime" type="range" min="5" max="15")
                b-input-group-text(slot="append")
                  div(style="text-transform: none;") {{ refreshTime }} s
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th.sticky-position
                        span {{ $tc('ui.leagues', 1) }}
                      th.sticky-position
                        span {{ $t('ui.home') }}
                      th.sticky-position
                        span {{ $t('ui.away') }}
                      th.sticky-position(width=80)
                        span {{ $t("ui.short.match_date") }}
                      th.sticky-position(width=80)
                        span {{ $t("ui.short.match_time") }}
                  tbody.clusterize-content
                    tr(v-if="pendingList.length == 0")
                      td(colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in pendingList")
                      td
                        span {{ item.parent_sport_type }}
                      td
                        span(:title="item.prefer_league_name") {{ item.prefer_league_name }}
                      td
                        span(:title="item.prefer_home_name") {{ item.prefer_home_name }}
                      td
                        span(:title="item.prefer_away_name") {{ item.prefer_away_name }}
                      td
                        span {{ $moment(item.parent_match_date).format("YYYY-MM-DD") }}
                      td
                        span {{ item.parent_match_time }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    purgeTeamSearch: '',
    pendingList: [],
    purgeTeamTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    timerId: null,
    refreshTime: 5,
    refreshUpdate: "",
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  created: function() {
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.getPreAddMatchPendingList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    getPreAddMatchPendingList: function() {
      let url = config.matchPreAddPendingListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pendingList = response.data.tbl_match_pre_add_pending_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getPreAddMatchPendingList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>